import { Grid, withStyles } from "@material-ui/core";
import React from "react";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
const style = () => ({
  button2: {
    marginRight: "10px",
  },
  buttonDelContainer: {
    marginTop: "10px",
  },
  leftButton: {
    width: "100%",
    textAlign: "left",
    marginLeft: "2%",
    marginTop: "25px",
  },
});
const SchemeChargeDetail = ({
  classes,

  chargeDetails,
}) => {
  return (
    chargeDetails?.length > 0 &&
    chargeDetails?.map((item, index) => (
      <Grid item xs={12} sm={12} md={12} key={index} style={{ display: "flex" }}>
        <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
            label="Charge Nature"
            required
            value={chargeDetails?.[index]?.chargeNature}
            disabled={true}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
            label="Days"
            required
            value={chargeDetails?.[index]?.days}
            disabled={true}
            type="chargeDays"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
            label="Value"
            required
            value={chargeDetails?.[index]?.value}
            disabled={true}
            type="Value"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
            label="MinAmount"
            required
            value={chargeDetails?.[index]?.minAmt}
            disabled={true}
            type="MinAmount"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
            label="MinAmount"
            required
            value={chargeDetails?.[index]?.maxAmt}
            disabled={true}
            type="MinAmount"
          />
        </Grid>
      </Grid>
    ))
  );
};
export default withStyles(style)(SchemeChargeDetail);
